import analytics from './segment';

/**
 * Identify the user to Segment
 *
 * @param userUid The user's Analytics UID
 * @param traits The entitlements User object
 */
export const identify = (userAnalyticsId, traits) => {
  analytics.identify(userAnalyticsId, traits);
};
export const setBaseProperties = analytics.setBaseProperties;
export const track = analytics.track;
export const waitForBaseProperties = analytics.waitForBaseProperties;
export const getBaseProperty = analytics.getBaseProperty;
export const load = analytics.load;
export { default as MockAnalyticsStore } from './MockAnalyticsStore';
//# sourceMappingURL=index.js.map